import '../styles/mainMenu.css';
import { useNavigate } from 'react-router-dom';
import { useState } from 'react';
import { useEffect } from 'react';
import { useRef } from 'react';
import useAuth from "../components/useAuth.js";

const defaultLogo = "/logos/placeholder-logo.png";

export default function MainMenu() {
  const { databaseName, userName, clientName } = useAuth();
  const navigate = useNavigate();

  const checkSessionAndNavigate = async (route) => {

    try {

      const response = await fetch(
        "api/verifySession.php",
        {
          method: "GET",
          credentials: "include"
        }
      );

      if (response.status === 401) {

        localStorage.clear();

        alert("Sesión expirada");

        navigate("/");

        return;
      }

      navigate(route);

    } catch (error) {

      console.error("Error verificando sesión:", error);

      alert("Error verificando sesión");
    }
  };

  const [logoSrc, setLogoSrc] = useState(defaultLogo); //DECLARACIÓN DE LAS VARIABLES DEL LOGO DEFAULT

    //-- SELECCION DE LOGO CLIENTE

    const fileInputRef = useRef(null);

    const handleLogoClick = () => {

      const ok = window.confirm(
        "¿Seleccionar nuevo logo de empresa?"
      );

      if (!ok) return;

      fileInputRef.current?.click();
    };

    const handleLogoUpload = async (event) => {

      const file = event.target.files?.[0];

      if (!file) return;

      const extension =
        file.name.split(".").pop().toLowerCase();

      if (!["png", "jpg", "jpeg"].includes(extension)) {

        alert("Solo se permiten PNG o JPG");

        return;
      }

      if (file.size > 5 * 1024 * 1024) {

        alert("El logo no puede superar 5MB");

        return;
      }

      const formData = new FormData();

      formData.append("logo", file);

      try {

        const response = await fetch(
          "api/uploadLogo.php",
          {
            method: "POST",
            credentials: "include",
            body: formData
          }
        );

        const result = await response.json();

        if (!result.success) {

          alert(result.message || "Error subiendo logo");

          return;
        }

        const timestamp = Date.now();

        setLogoSrc(
          `${process.env.PUBLIC_URL}/logos/${databaseName}-logo.${result.extension}?v=${timestamp}`
        );

        alert("Logo actualizado");

      } catch (error) {

        console.error(error);

        alert("Error subiendo logo");
      }
    };

    //------------------
  //-------------- CAPTURA DINÁMICA DEL LOGO DEL CLIENTE SEGÚN EL NOMBRE DE FANTASÍA

  useEffect(() => {
    document.title = "Galileo Analytics - Menu";
  }, []);

  // useEffect(() => {

  //   obtenerUltimaSincronizacion();

  // }, []);

  useEffect(() => {

    if (!clientName) return;

    const logos = [

      `${process.env.PUBLIC_URL}/logos/${databaseName}-logo.png?v=${Date.now()}`,

      `${process.env.PUBLIC_URL}/logos/${databaseName}-logo.jpg?v=${Date.now()}`,

      `${process.env.PUBLIC_URL}/logos/${databaseName}-logo.jpeg?v=${Date.now()}`
    ];

    const tryLogo = (index) => {

      if (index >= logos.length) {

        setLogoSrc(defaultLogo);

        return;
      }

      const img = new Image();

      img.onload = () => setLogoSrc(logos[index]);

      img.onerror = () => tryLogo(index + 1);

      img.src = logos[index];
    };

    tryLogo(0);

  }, [clientName, databaseName]);
  //console.log(clientName);

  useEffect(() => {

    const verifySession = async () => {

      try {

        const response = await fetch(
          "api/verifySession.php",
          {
            method: "GET",
            credentials: "include"
          }
        );

        if (response.status === 401) {

          localStorage.clear();

          alert("Sesión expirada");

          navigate("/");

          return;
        }

      } catch (error) {

        console.error("Error verificando sesión:", error);

        localStorage.clear();

        navigate("/");
      }
    };

    verifySession();

  }, [navigate]);
//OBTENER ULTIMA SINCRO
  const [ultimaSincronizacion, setUltimaSincronizacion] = useState(null);

  // const obtenerUltimaSincronizacion = async () => {

  //   try {

  //     const response = await fetch(
  //       "api/lastSync.php",
  //       {
  //         method: "GET",
  //         credentials: "include"
  //       }
  //     );
  //     if (response.status === 401) {
  //       return;
  //     }
  //     // Primero obtenemos el texto crudo
  //     const text = await response.text();
  //     //console.log("Respuesta lastSync.php:", text);
  //     let data;
  //     try {
  //       data = JSON.parse(text);
  //     } catch (parseError) {
  //       // console.error(
  //       //   "Error parseando respuesta de lastSync.php:",
  //       //   text
  //       // );

  //       return;
  //     }
  //     if (data.success) {
  //       setUltimaSincronizacion(
  //         data.ultimaSincronizacion
  //       );
  //     } else {
  //       // console.error(
  //       //   "Error en lastSync.php:",
  //       //   data.message || data.error || "Error desconocido"
  //       // );

  //     }
  //   } catch (error) {

  //     console.error(
  //       "Error obteniendo última sincronización:",
  //       error
  //     );

  //   }
  // };

  //DECLARACIÓN Y MANEJO DE BOTONES
  const menuButtons = [
    { label: "Artículos y Stock", route: "/articulos-stock", icon: require("../assets/stock-icon.png") },
    { label: "Ventas", route: "/ventas", icon: require("../assets/money-icon.png") },
    { label: "Ventas por Artículo", route: "/ventas-por-articulo", icon: require("../assets/article-icon.png") },
    { label: "Movimientos de Caja", route: "/movimientos-de-caja", icon: require("../assets/caja-icon.png") },
    { label: "Cuentas Corrientes", route: "/cuentas-corrientes", icon: require("../assets/account-icon.png") },
  ];


  return (
    <>
    <div className="main-menu-container">
      {/* Banner */}
      <header className="main-menu-banner">
        <h1>
          <span className='title-galileo'>Galileo</span> <em className='title-insight'>Analytics</em>
        </h1>
          <h3>
          {/* <div className="sync-info">
            <span>
              Última sincronización:{" "}
              {ultimaSincronizacion || "Sin datos"}
            </span>
          </div> */}
        </h3>
        <img 
          className='banner-system-logo'
          src={`${process.env.PUBLIC_URL}/logos/galileoinsight-logo.png`}
          alt="Logo Sistema"
        />
          <div className='banner-client-data'>
          <>
            <img
              className="banner-client-logo"
              src={logoSrc}
              alt="Logo Cliente"
              onClick={handleLogoClick}
              style={{ cursor: "pointer" }}
              title="Cambiar logo"
            />

            <input
              ref={fileInputRef}
              type="file"
              accept=".png,.jpg,.jpeg"
              style={{ display: "none" }}
              onChange={handleLogoUpload}
            />
          </>
            <h3>Licenciado a: {clientName}</h3>
          </div>
        
      </header>

      <main className="main-menu-body">
        {/*INICIALIZACION DE MAPEO DE BOTONES*/}
        {menuButtons.map((item, index) => (
      
      
      /* COMPONENTE DEL LOS BOTONES */  
      <button
            key={index}
            className='menu-button'
            onClick={() => checkSessionAndNavigate(item.route)}
          >
            <img 
              src={item.icon}
              alt={item.label}
              className='menu-button-icon'
            />
            {item.label}
      </button>

        ))}
        {/*BOTÓN UNICO LOGOUT*/}
        <button
          className="menu-button logout"
          onClick={async () => {

            try {

              await fetch(
                "api/logout.php",
                {
                  method: "POST",
                  credentials: "include"
                }
              );

            } catch (error) {
              console.error(error);
            }

            localStorage.clear();

            navigate("/");
          }}
        >
          Cerrar sesión
        </button>
      </main>
    </div>
    <div className='menu-footer'>
      <footer>
          <span>
            Sesión Actual: {userName}
          </span>
      </footer>
    </div>
  </>
  );
}
